class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    const cartLinkBar = document.querySelector('#cart-icon-bubble-bar');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
    cartLinkBar.setAttribute('role', 'button');
    cartLinkBar.setAttribute('aria-haspopup', 'dialog');
    cartLinkBar.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLinkBar);
    });
    cartLinkBar.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLinkBar);
      }
    });
  }

  open(triggeredBy) {
    // BaadMay code start for cart drawer
    setTimeout(() => {
      var domainShop = "bata-pakistan.myshopify.com";
    
      function calculateCartInstallment() {
          var storedData = sessionStorage.getItem("baadmayData");
    
          if (storedData) {
              processData(JSON.parse(storedData));
          } else {
              fetch("https://cms.baadmay.com/Fees?merchant_name=" + domainShop)
                .then(response => response.json())
                .then(data => {
                    sessionStorage.setItem("baadmayData", JSON.stringify(data));
                    processData(data);
                })
                .catch(error => console.error("Error fetching data:", error));
          }
      }
    
      function processData(result) {
          var valAdd = result[0].fee;
          var divVal = parseInt(valAdd) / 100;
          sessionStorage.setItem("percentageAmount", divVal);
          var perctoAddCartPage1 = sessionStorage.getItem("percentageAmount");
    
          var priceDivideElements = document.querySelectorAll('baadmaypricerre');
          priceDivideElements.forEach(priceDivideElement => {
              var cartPageTotal1 = parseFloat(priceDivideElement.getAttribute('total-cart-price'));
              var multiCartPrice1 = cartPageTotal1 * perctoAddCartPage1;
              var finalCartPrice1 = Math.floor(parseFloat(cartPageTotal1 + multiCartPrice1) / 3);
    
              priceDivideElement.textContent = parseFloat(finalCartPrice1).toLocaleString();
          });
      }
    
      calculateCartInstallment();
      
      var venobox = new VenoBox({
        selector: '.baadmay-modal',
        closeColor: '#000',
        closeBackground: 'transparent',
        overlayColor: 'rgba(0,0,0,.75)',
        overlayClose: false,
        customClass: 'baadmay-modal-container',
      });
    
      document.addEventListener('click', function(event) {
        if (event.target.classList.contains('baadmay-popup-close')) {
          venobox.close();
        }
      });
    }, 1500); 
    // BaadMay code end for cart drawer
    
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-icon-bubble-bar',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
            {
        id: 'cart-icon-bubble-bar',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
